"use client";

import React, { useState } from "react";
import Image from "next/image";
import { useTranslations } from "i18n/useTranslations";
import { FILES } from "i18n/constants";
import { Dialog } from "@hubble/web";

import { handleContentfulLoader } from "utils/images/contentfulLoader";
import { Body } from "app/_components/components/Text/Body";

const DownloadGeminiMobileAppContent = ({
  onClick
}: {
  onClick?: () => void;
}) => {
  const t = useTranslations(FILES.PRICES);

  return (
    <div
      onClick={onClick}
      className="small-desktop:min-w-[230px] mx-auto flex cursor-pointer items-center rounded-[16px] bg-white p-[16px] shadow-[0_8px_32px_0_rgba(0,0,0,0.08)] transition-shadow hover:shadow-[0_12px_40px_0_rgba(0,0,0,0.12)]"
    >
      <div className="max-auto flex items-center">
        <Image
          priority
          src="https://cdn.builder.io/api/v1/image/assets%2F1b77ce3a269a43e985e77f3d65f715ba%2F8c8f53eeeb9e4540969ccba229bb3235?quality=100"
          alt="qr"
          height={50}
          width={50}
          loader={handleContentfulLoader}
        />
      </div>
      <div className="ml-[24px] flex flex-col">
        <Body size="sm" className="!text-[12px] leading-[16px] font-normal">
          {t("downloadThe")}
        </Body>
        <Body
          size="sm"
          className="!text-[12px] leading-[16px] font-semibold text-[#343536]"
        >
          {t("geminiMobileApp")}
        </Body>
      </div>
    </div>
  );
};

const DownloadGeminiMobileApp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations(FILES.PRICES);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger asChild>
        <DownloadGeminiMobileAppContent onClick={() => setIsOpen(true)} />
      </Dialog.Trigger>
      <Dialog.Container>
        <Dialog.Header>
          <p className="text-center text-xl leading-8 font-semibold text-[#010304]">
            {t("downloadTheApp")}
          </p>
        </Dialog.Header>
        <Dialog.Content>
          <div className="mt-[24px] flex w-full items-center justify-center">
            <Image
              src="https://images.ctfassets.net/jg6lo9a2ukvr/3uYv8qQCa2bAkZUb2zkRh8/9ef3d5cb30a168df9a02cd381c979df2/Modal__1_.png"
              alt="Mobile App QR Code"
              height={285}
              width={459}
              loader={handleContentfulLoader}
            />
          </div>
        </Dialog.Content>
      </Dialog.Container>
    </Dialog>
  );
};

export default DownloadGeminiMobileApp;
